import { draftReturnAtomFamily } from "@babackapp/return-widget-components/atoms/draft-return.atom";
import { useCreateReturnRequest } from "@babackapp/return-widget-components/mutations/use-create-return-request";
import { useDraftReturn } from "@babackapp/return-widget-components/hooks/use-draft-return";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { useWidgetParams } from "./use-widget-params";

export type CompleteStatus = "idle" | "pending" | "success" | "error";

export type UseCompleteReturn = {
  status: CompleteStatus;
  returnRequestId: string | undefined;
  error: Error | null;
  confirm: () => void;
};

export function useComplete(): UseCompleteReturn {
  const { orderId, shopSlug } = useWidgetParams();
  const draft = useDraftReturn(orderId);
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));
  const mutation = useCreateReturnRequest(orderId, shopSlug);

  const confirm = useCallback(() => {
    if (!draft || mutation.status === "pending") return;

    mutation.mutate(draft, {
      onSuccess: () => {
        setDraft(null);
      },
    });
  }, [draft, mutation, setDraft]);

  return {
    status: mutation.status === "idle" ? "idle" : mutation.status,
    returnRequestId: mutation.data?.id,
    error: mutation.error,
    confirm,
  };
}
